import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import config from '../config';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const storeToken = (token) => localStorage.setItem('vs_token', token);
  const clearToken = () => localStorage.removeItem('vs_token');

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem('vs_token');
    if (!token) {
      setAuthLoading(false);
      return;
    }
    try {
      const res = await fetch(`${config.apiBaseURL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setUser(await res.json());
      } else {
        clearToken();
      }
    } catch {
      // network error — don't log out, just leave user as null
    } finally {
      setAuthLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = (token, userData) => {
    storeToken(token);
    setUser(userData);
  };

  const logout = async () => {
    const token = localStorage.getItem('vs_token');
    if (token) {
      fetch(`${config.apiBaseURL}/api/auth/logout`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => {});
    }
    clearToken();
    setUser(null);
  };

  const isSubscribed = user?.subscription_status === 'active';

  return (
    <AuthContext.Provider value={{ user, authLoading, login, logout, isSubscribed, refreshUser: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function getToken() {
  return localStorage.getItem('vs_token');
}
